import type { Link } from '../../types/link.js';
import type { Tag, TagType } from '../../types/tag.js';

export interface TagCandidate {
  key: string;
  label: string;
  count: number;
}

/**
 * 指定 type のタグだけを Link 一覧から抽出し、出現回数で集計する。
 * 並び順: count 降順 → name 昇順。マスタにない名前は無視する。
 */
export function extractTagCandidatesByType(
  links: readonly Link[],
  tagMaster: readonly Tag[],
  type: TagType,
): TagCandidate[] {
  const targetNames = new Set(
    tagMaster.filter((t) => t.type === type).map((t) => t.name),
  );
  const counts = new Map<string, number>();
  for (const link of links) {
    for (const name of link.tags) {
      if (!targetNames.has(name)) continue;
      counts.set(name, (counts.get(name) ?? 0) + 1);
    }
  }
  return [...counts.entries()]
    .map(([name, count]) => ({ key: name, label: name, count }))
    .sort((a, b) => (b.count - a.count) || a.key.localeCompare(b.key, 'ja'));
}

/**
 * 選択中のタグ名のうち 1 つでも Link.tags に含まれていれば true（OR 条件）。
 * 選択 0 件はフィルタ無効として常に true を返す。
 */
export function matchesAnyTag(
  linkTags: readonly string[],
  selected: readonly string[],
): boolean {
  if (selected.length === 0) return true;
  return selected.some((s) => linkTags.includes(s));
}
